import React from 'react';
import { isEmpty } from 'lodash';
import { INLINE_1 } from 'Components/frameworks/card/Card.constants';
import type { CardProps } from 'Components/frameworks/card/Card';
import { Card } from 'Components/frameworks/card/Card';
import { Product } from 'Components/widgets/product/Product';
import type { ProductProps } from 'Components/widgets/product/Product.utils';
type ProductTeaserProps = {
  card: CardProps;
  index?: number;
  lineName?: string;
  product: ProductProps;
};
export const ProductTeaser = ({ card, product }: ProductTeaserProps) => {
  if (isEmpty(card)) {
    return null;
  }

  const hasProduct = !isEmpty(product);

  if (!hasProduct) {
    return <Card layout={INLINE_1} {...card} />;
  }

  return (
    <div className="flex flex-col gap-20 sm:flex-row">
      <Card {...card} className="lg:3/4 w-full sm:w-1/2 md:w-2/3" layout={INLINE_1} />
      <Product {...product} className="lg:1/4 w-full sm:w-1/2 md:w-1/3" />
    </div>
  );
};
